import BlockView from 'views/block/base-block-view';
import LocaleService from 'services/locale-service';
export default class ChartView extends BlockView {
  constructor(options) {
    super(options);
    this.className = 'chart';
  }
  load() {
    this.canvas = this.$el.find('canvas').get(0).getContext('2d');
    this.type = this.model.get('chart_type');
    this.data = this.model.get('data') || this.script.data;
    this.options = this.model.get('options') || {};
    this._updateAriaLabel(); //generates aria label

    if (this.model.get('onAnimationProgress')) {
      this.options.onAnimationProgress = this.script[this.model.get('onAnimationProgress')];
    }

    if (this.model.get('onAnimationComplete')) {
      this.options.onAnimationComplete = this.script[this.model.get('onAnimationComplete')];
    }
    if (this.type === 'Pie') {
      this.data = this.data.map(d => {
        return Object.assign(d, {
          label: LocaleService.t(d.label),
        });
      });
    }
    this.chart = new Chart(this.canvas)[this.type](this.data, this.options);

    this.subscribeEvent('block:values:change', (values, blockView, pageView) => {
      if (this.script && this.script[this.model.get('onUpdate')]) {
        this.data = this.script[this.model.get('onUpdate')](values, this.chart, this.data, blockView, pageView);
      }
      var currentTotal;
      this._updateAriaLabel(); //update label on change
      switch (this.type) {
        case 'Line':
        case 'Radar':
          currentTotal = _(this.chart.datasets[0].points).reduce((r, p) => p.value + r, 0);
          this.data.datasets.forEach((ds, ds_i) => {
            ds.data.forEach((d, i) => (this.chart.datasets[ds_i].points[i].value = d));
          });
          break;
        case 'Bar':
          currentTotal = _(this.chart.datasets[0].bars).reduce((r, b) => b.value + r, 0);
          this.data.datasets.forEach((ds, ds_i) => {
            ds.data.forEach((d, i) => (this.chart.datasets[ds_i].bars[i].value = d.value));
          });
          break;
        case 'PolarArea':
        case 'Pie':
        case 'Doughnut':
          currentTotal = _(this.chart.segments).reduce((r, s) => s.value + r, 0);
          this.chart.segments.forEach((s, i) => {
            if (!this.data[i] || this.data[i].label !== this.chart.segments[i].label) {
              this.chart.removeData(i);
            } else {
              this.chart.segments[i].fillColor = this.data[i].color;
              this.chart.segments[i].highlightColor = this.data[i].highlight;
              this.chart.segments[i].value = this.data[i].value;
            }
          });
          this.data.forEach((d, i) => {
            if (!this.chart.segments[i] || this.data[i].label !== this.chart.segments[i].label) {
              this.chart.addData(d, i);
            }
          });
          break;
        default:
          break;
      }

      if (currentTotal <= 0) {
        this.chart = new Chart(this.canvas)[this.type](this.data, this.options);
      } else {
        this.chart.update();
      }
      this.publishEvent('chart:data:changed', this.chart);
    });
  }
  play() {
    this.readyToGo();
  }
  //Function to update aria label // label = chart_type + sr_chart_title + sr_scale_label + label: value pairs
  _updateAriaLabel() {
    let label = `${this.type} ${this.model.get('sr_chart_title') || ''} ${this.model.get('sr_scale_label') || ''} `;
    if (this.data.datasets) {
      //alt label no internationalization//label += ` Values in ${this.options.scaleLabel||''} from ${this.options.scaleStartValue} to ${this.options.scaleSteps * this.options.scaleStepWidth} `;
      label += this.data.datasets.reduce((r, p) => `${r} ${p.label}: ${p.data[0]}`, '');
    } else if (this.data) {
      label += this.data.reduce((r, p) => `${r} ${p.label}: ${p.value}% `, '');
    }
    this.$el.find('canvas').attr('aria-label', label);
  }
}
